import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MoreIcon from "@mui/icons-material/MoreVert";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { Button, Drawer, List, ListItemButton, ListItemText, Collapse, Divider } from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import styles from "./navbar.module.scss";

export default function Navbar() {
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  
  const [mobileOpen, setMobileOpen] = useState(false); 
  const [openMobileAdd, setOpenMobileAdd] = useState(false); 

  const navigate = useNavigate();
  const [buttonClicked, setButtonClicked] = useState<string>();
  const [showDropdownFind, setShowDropdownFind] = useState<boolean>(false);
  const [showDropdownAdd, setShowDropdownAdd] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const handleLinkHover = (name: string) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    if (name === "find") {
      setShowDropdownFind(true);
    } else if (name === "add") {
      setShowDropdownAdd(true);
      setTimeout(() => {
        const dropdown = document.querySelector(`.${styles.dropdown}`);
        if (dropdown) {
          dropdown.classList.add(styles.visible);
        }
      }, 10);
    }
  };

  const handleMouseLeave = (name: string) => {
    const timeout = setTimeout(() => {
      if (name === "find") {
        setShowDropdownFind(false);
      } else if (name === "add") {
        const dropdown = document.querySelector(`.${styles.dropdown}`);
        if (dropdown) {
          dropdown.classList.remove(styles.visible);
        }
        setTimeout(() => {
          setShowDropdownAdd(false);
        }, 500);
      }
    }, 300);
    setTimeoutId(timeout);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileAddClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenMobileAdd(!openMobileAdd);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClicked = (linkId: string) => {
    setButtonClicked(linkId);
    setMobileOpen(false); 
  };

  const tokenAvailable = () => {
    const token = localStorage.getItem("token");
    return !!token;
  };

  useEffect(() => {
    const currentPath = window.location.pathname as string;
    setButtonClicked(currentPath);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );
  
  const drawerContent = (
    <Box sx={{ width: 250 }} role="presentation">
      <Toolbar sx={{ justifyContent: "center" }}>
        <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            Slinge<b>rr</b>
        </p>
      </Toolbar>
      <Divider />
      
      <List>
        {/* FIND */}
        <ListItemButton 
            onClick={() => { navigate("/find"); handleButtonClicked("/find"); }}
            selected={buttonClicked === "/find"}
        >
            <ListItemText primary="Find" />
        </ListItemButton>

        {/* ADD (Rozwijane) */}
        <ListItemButton onClick={handleMobileAddClick}>
            <ListItemText primary="Add" />
            {openMobileAdd ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        
        <Collapse in={openMobileAdd} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
                <ListItemButton 
                    sx={{ pl: 4 }} 
                    onClick={() => { navigate("/project/add"); handleButtonClicked("/project/add"); }}
                    selected={buttonClicked === "/project/add"}
                >
                    <ListItemText primary="Add Project" />
                </ListItemButton>
                <ListItemButton 
                    sx={{ pl: 4 }} 
                    onClick={() => { navigate("/teammates/add"); handleButtonClicked("/teammates/add"); }}
                    selected={buttonClicked === "/teammates/add"}
                >
                    <ListItemText primary="Add Teammate" />
                </ListItemButton>
            </List>
        </Collapse>

        <ListItemButton 
            onClick={() => { navigate("/feedback"); handleButtonClicked("/feedback"); }}
            selected={buttonClicked === "/feedback"}
        >
             <ListItemText primary="Feedback" />
             <FeedbackIcon fontSize="small" sx={{ ml: 1, color: 'gray' }} />
        </ListItemButton>

        <ListItemButton 
             onClick={() => { navigate("/feed"); handleButtonClicked("/feed"); }}
             selected={buttonClicked === "/feed"}
        >
            <ListItemText primary="Feed" />
        </ListItemButton>

        <Divider sx={{ my: 2 }} />

        {tokenAvailable() ? (
            <ListItemButton 
                onClick={() => { navigate("/conversations"); handleButtonClicked("/conversations"); }}
                selected={buttonClicked === "/conversations"}
            >
                <ListItemText primary="My Account" />
            </ListItemButton>
        ) : (
            <ListItemButton onClick={() => { navigate("/login"); handleButtonClicked("/login"); }}>
                <ListItemText primary="Sign in" />
            </ListItemButton>
        )}
      </List>
    </Box>
  );

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" className="navbar">
          <Toolbar>
            <p onClick={() => navigate("/")} style={{ cursor: "pointer", marginRight: "1rem" }}>
              Slinge<b>rr</b>
            </p>

            <Box sx={{ flexGrow: 1 }} />

            <Box
              sx={{ display: { xs: "none", md: "flex" } }}
              className="navbar__linksBox"
            >
              <div className={styles.navLinkBox}>
                <Link
                  className={styles.navButton}
                  style={{
                    fontWeight: buttonClicked === "/find" ? "bold" : "",
                  }}
                  onClick={() => handleButtonClicked("/find")}
                  to="/find"
                >
                  Find
                </Link>
              </div>

              {/* Add Dropdown */}
              <div className={styles.navLinkBox}>
                <Link
                  className={styles.navButton}
                  style={{
                    fontWeight:
                      buttonClicked === "/project/add" ||
                      buttonClicked === "/teammates/add"
                        ? "bold"
                        : "",
                  }}
                  onClick={() => handleButtonClicked("/project/add")}
                  to="/project/add"
                  onMouseEnter={() => handleLinkHover("add")}
                  onMouseLeave={() => handleMouseLeave("add")}
                >
                  Add
                </Link>
                <div
                  className={`${styles.dropdown} ${showDropdownAdd ? styles.visible : ''}`}
                  onMouseEnter={() => handleLinkHover("add")}
                  onMouseLeave={() => handleMouseLeave("add")}
                >
                  <Link className={styles.dropdown__link} to={"/project/add"}>
                    Add Project
                  </Link>
                  <Link className={styles.dropdown__link} to={"/teammates/add"}>
                    Add Teammate
                  </Link>
                </div>
              </div>

              <div 
                className={`${styles.feedbackButton} ${buttonClicked === "/feedback" ? styles.active : ""}`}
                onClick={() => navigate("/feedback")}
                style={{ marginRight: "1rem" }}
              >
                <FeedbackIcon />
              </div>

              {tokenAvailable() ? (
                <Link
                  className={styles.navButton}
                  style={{
                    fontWeight: buttonClicked === "/conversations" ? "bold" : "",
                  }}
                  onClick={() => handleButtonClicked("/conversations")}
                  to="/conversations"
                >
                  My Account
                </Link>
              ) : (
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => navigate("/login")}
                >
                  Sign in
                </Button>
              )}
            </Box>

            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                color="inherit"
              >
                <MenuIcon/>
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>

        <Drawer
            anchor="right" 
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
                keepMounted: true, 
            }}
        >
            {drawerContent}
        </Drawer>

        {renderMenu}
      </Box>
    </>
  );
}